import { useTranslation } from "react-i18next";

export const HelpCentreLink = () => {
  const { t } = useTranslation();

  return <a href={"https://help.gobolt.com"}>{t("GoBolt Help Centre")}</a>;
};
